import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';
import { KeywordMapValidator } from '../Vaildator/KeywordMapValidator';

export function KeywordMapAddRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.KeywordMapAdd', {
		url: '/keyword_map/add',
		controllerAs: 'vm',
		controller: KeywordMapAddCtrl,
		templateUrl: '/ng/hub/KeywordMap/Edit/KeywordMapEditCtrl.html?' + window.BUILD,
		resolve: {},
	});
}

export class KeywordMapAddCtrl {
	constructor(Api, modal) {
		'ngInject';
		// save injections
		this.Api = Api;
		this.modal = modal;
		// setup blank record
		this.scope = undefined;
		this.map = {
			from_word: '',
			to_tag: '',
			is_case_sensitive: undefined,
			account_id: undefined,
			hub_id: undefined,
		};
	}

	cancel() {
		this.$reject();
	}

	save() {
		const scopeVars = {
			modal: this.modal,
			scope: this.scope,
			map: this.map,
			hubId: this.map.hub_id,
			accountId: this.map.account_id,
		};
		if (!KeywordMapValidator.isValid(scopeVars)) {
			return;
		}
		this.Api.create(`/keyword_maps`, this.map).then(
			() => {
				this.$resolve({ refresh: true });
			},
			() => {}
		);
	}

	checkErrors() {
		this.error = KeywordMapValidator.getError(this.map);
	}
}
